import { useApiRequest } from "@hooks/use-api-request";
import { HttpMethod } from "@lib/http.helpers";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useUpdateBudgetPlan = (budgetPlanId, onSuccess) => {
  const queryClient = useQueryClient();
  const mutationFn = useApiRequest({
    url: `/budget-plans/${budgetPlanId}`,
    method: HttpMethod.Put,
  });

  return useMutation({
    mutationKey: ["update-user-budget-plan", budgetPlanId],
    mutationFn: (data) => mutationFn({ data }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["budget-plan"] });
      queryClient.invalidateQueries({
        queryKey: ["user-journey-status"],
        exact: true,
      });

      onSuccess?.();
    },
  });
};
